/**
 * @typedef {{ width: number, height: number }} Viewport
 */

export function createViewport(target = window) {
  const listeners = new Set();
  const size = {
    width: target.innerWidth,
    height: target.innerHeight,
  };

  function update() {
    size.width = target.innerWidth;
    size.height = target.innerHeight;
    listeners.forEach((listener) => listener({ ...size }));
  }

  target.addEventListener("resize", update);

  return {
    getSize: () => ({ ...size }),
    subscribe(listener, { immediate = true } = {}) {
      listeners.add(listener);
      if (immediate) listener({ ...size });
      return () => listeners.delete(listener);
    },
    destroy() {
      target.removeEventListener("resize", update);
      listeners.clear();
    },
  };
}
